<!-- ── Toolbar: search + filter + download + actions ─────────────────────── -->
<div class="list-external-references__toolbar">
  <ui-form-field
    [formControl]="searchControl"
    [prefixIcon]="'search'"
    [placeholder]="'knowledge_base.external_references.search_placeholder' | translate"
    class="list-external-references__search"
  >
  </ui-form-field>
  <div class="filter-button-group">
    <button class="action-button" (click)="setFilter()" [ngClass]="{ activeFilter: hasActiveFilters() }">
      <div class="action-button-icon">
        <img src="assets/icones/filter_icon.svg" alt="" />
      </div>
      <span class="action-button-text">{{ "knowledge_base.filter" | translate }}</span>
      <div class="clear-icon-container">
        <img
          class="clear-icon"
          *ngIf="hasActiveFilters()"
          (click)="clearFilter(); $event.stopPropagation()"
          src="assets/icones/clear-icon.svg"
          alt=""
        />
        <div class="clear-tooltip" *ngIf="hasActiveFilters()">
          {{ "common.clear_filters" | translate }}
        </div>
      </div>
    </button>
  </div>
  <ui-button [label]="'knowledge_base.download' | translate" type="secondary" icon="download_icon" (click)="exportList()"> </ui-button>
  <div class="list-external-references__toolbar-actions">
    <!-- Bulk actions for the current selection live in the floating
         ui-bulk-actions-bar at the bottom of the table, not here. -->
    <ui-button
      *appHasPermission="{ module: 'knowledge_base', action: 'create' }"
      type="primary-text-outlined"
      icon="plus-cc"
      iconSize="large"
      [label]="'knowledge_base.external_references.add_external_reference' | translate"
      (click)="openCreateDialog()"
    >
    </ui-button>
    <ui-button
      *appHasPermission="{ module: 'knowledge_base', action: 'create' }"
      type="primary"
      icon="upload"
      [label]="'knowledge_base.upload_file' | translate"
      (click)="openImportDialog()"
    >
    </ui-button>
  </div>
</div>

<!-- ── Table ─────────────────────────────────────────────────────────────── -->
<div class="list-external-references__table" [class.list-external-references__table--with-bulk-bar]="selection.hasSelection">
  <!-- Header -->
  <div class="list-external-references__table-header">
    <div class="list-external-references__table-cell list-external-references__table-cell--checkbox" (click)="$event.stopPropagation()">
      <ui-checkbox
        [checked]="selection.isAllSelected"
        [indeterminate]="selection.isPartialSelected"
        [ariaLabel]="'common.select_all' | translate"
        (changed)="selection.toggleAll($event.checked)"
      ></ui-checkbox>
    </div>
    <div class="list-external-references__table-cell list-external-references__table-cell--sortable" (click)="onSort('product_name')">
      {{ "knowledge_base.external_references.col.product_name" | translate }}
      <div class="list-external-references__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'product_name' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'product_name' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-external-references__table-cell list-external-references__table-cell--sortable" (click)="onSort('sku')">
      {{ "knowledge_base.external_references.col.sku" | translate }}
      <div class="list-external-references__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'sku' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'sku' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-external-references__table-cell list-external-references__table-cell--sortable" (click)="onSort('customer_name')">
      {{ "knowledge_base.external_references.col.customer" | translate }}
      <div class="list-external-references__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'customer_name' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'customer_name' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-external-references__table-cell list-external-references__table-cell--sortable" (click)="onSort('reference_code')">
      {{ "knowledge_base.external_references.col.external_reference" | translate }}
      <div class="list-external-references__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'reference_code' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'reference_code' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-external-references__table-cell list-external-references__table-cell--sortable" (click)="onSort('create_date')">
      {{ "knowledge_base.external_references.col.created_date" | translate }}
      <div class="list-external-references__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'create_date' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'create_date' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-external-references__table-cell list-external-references__table-cell--sortable" (click)="onSort('source')">
      {{ "knowledge_base.external_references.col.source" | translate }}
      <div class="list-external-references__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'source' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'source' && sortMode === 'desc'"></span>
      </div>
    </div>
  </div>

  <!-- Scrollable body -->
  <div class="list-external-references__table-body">
    <!-- Loading state -->
    <div class="list-external-references__loading" *ngIf="loading$ | async">
      <div class="list-external-references__loading-spinner"></div>
    </div>

    <!-- Rows -->
    <ng-container *ngIf="!(loading$ | async) && sortedReferences.length > 0">
      <div *ngFor="let ref of sortedReferences" class="list-external-references__table-row" (click)="openEditDialog(ref)">
        <div class="list-external-references__table-cell list-external-references__table-cell--checkbox" (click)="$event.stopPropagation()">
          <ui-checkbox
            [checked]="selection.isSelected(ref.id)"
            [ariaLabel]="'common.select' | translate"
            (changed)="selection.toggleOne(ref.id, $event.checked, $event)"
          ></ui-checkbox>
        </div>
        <div class="list-external-references__table-cell">
          <a
            *ngIf="ref.product_id"
            class="list-external-references__product-link"
            [routerLink]="['/inventory', ref.product_id]"
            target="_blank"
            (click)="$event.stopPropagation()"
          >
            {{ ref.product_name }}
          </a>
          <span *ngIf="!ref.product_id">--</span>
        </div>
        <div class="list-external-references__table-cell">
          <span class="list-external-references__sku">
            {{ ref.sku || "--" }}
            <mat-icon
              *ngIf="hasInvalidSku(ref)"
              class="list-external-references__sku-warning"
              [matTooltip]="'knowledge_base.external_references.sku_warning_tooltip' | translate"
              matTooltipPosition="above"
            >
              warning
            </mat-icon>
          </span>
        </div>
        <div class="list-external-references__table-cell">{{ ref.customer_name || "--" }}</div>
        <div class="list-external-references__table-cell">{{ ref.reference_code }}</div>
        <div class="list-external-references__table-cell">{{ ref.create_date ? (ref.create_date | date: "dd/MM/yyyy") : "--" }}</div>
        <div class="list-external-references__table-cell">
          <span class="list-external-references__source-badge list-external-references__source-badge--{{ ref.source }}">
            {{ "knowledge_base.external_references.source." + ref.source | translate }}
          </span>
        </div>
      </div>
    </ng-container>

    <!-- Empty state -->
    <div *ngIf="sortedReferences.length === 0 && !(loading$ | async)" class="list-external-references__empty">
      <ng-container *ngIf="!keyword">
        <img class="list-external-references__empty-illustration" src="assets/icones/no-result-search.svg" alt="" />
        <h3>{{ "knowledge_base.external_references.empty_state" | translate }}</h3>
      </ng-container>
      <ng-container *ngIf="keyword">
        <img class="list-external-references__empty-illustration" src="assets/icones/no-result-search.svg" alt="" />
        <h3>{{ "knowledge_base.external_references.empty_state_search" | translate }}</h3>
      </ng-container>
    </div>
  </div>

  <!-- ───────────────────────────────────────────────────────────────────── -->
  <!-- Bulk actions for the current selection. Floats centred at the bottom of -->
  <!-- the table so selecting rows never reflows the toolbar above it.         -->
  <!-- ───────────────────────────────────────────────────────────────────── -->
  <ui-bulk-actions-bar
    *ngIf="selection.hasSelection"
    [count]="selection.count"
    (cleared)="selection.clear()"
  >
    <button
      *appHasPermission="{ module: 'knowledge_base', action: 'delete' }"
      class="ui-bulk-action ui-bulk-action--danger"
      (click)="bulkDelete()"
    >
      <ui-icon name="Trash2" size="medium"></ui-icon>
      <span>{{ 'common.delete' | translate }}</span>
    </button>
  </ui-bulk-actions-bar>
  <!-- ── END BULK ACTIONS BAR ─────────────────────────────────────────────── -->

  <!-- Pagination lives inside the bordered container, below the rows -->
  <app-pagination
    *ngIf="sortedReferences.length > 0"
    class="list-external-references__pagination"
    [pagination]="metadata$ | async"
    (toPageEvent)="toPage($event)"
  ></app-pagination>
</div>
